<template>
  <div>
    <div v-show="isFirst">
      <div style="margin-top: 10px;" class="cardDivClass">
        <el-row :gutter="12">
          <el-col :span="5">
            <div>
              <el-card shadow="hover" style="border-top:3px solid #0099FB;">
                <div slot="header">
                  <span>设备</span>
                </div>
                <div class="text item">
                  <div style="font-size: 24px;">
                    <span>{{totalDevice}}台</span>
                  </div>
                  <div style="color: #C8C9CC;margin-top: 5px;font-size: 12px;">
                    <span>总设备</span>
                  </div>
                </div>
              </el-card>
            </div>
          </el-col>
          <el-col :span="5">
            <div v-if="isVender">
              <el-card shadow="hover" style="border-top:3px solid #52C41A;">
                <div slot="header">
                  <span>设备</span>
                </div>
                <div>
                  <div style="font-size: 24px;">
                    <span>{{leaseDevice}}台</span>
                  </div>
                  <div style="color: #C8C9CC;margin-top: 5px;font-size: 12px;">
                    <span>租赁设备数</span>
                  </div>
                </div>
              </el-card>
            </div>
          </el-col>
          <el-col :span="5">
            <div v-if="isVender">
              <el-card shadow="hover" style="border-top:3px solid #52C41A;">
                <div slot="header">
                  <span>设备</span>
                </div>
                <div>
                  <div style="font-size: 24px;">
                    <span>{{buyoutDevice}}台</span>
                  </div>
                  <div style="color: #C8C9CC;margin-top: 5px;font-size: 12px;">
                    <span>售出设备数</span>
                  </div>
                </div>
              </el-card>
            </div>
          </el-col>
          <el-col :span="5">
            <div v-if="isVender">
              <el-card shadow="hover" style="border-top:3px solid #52C41A;">
                <div slot="header">
                  <span>设备</span>
                </div>
                <div>
                  <div style="font-size: 24px;">
                    <span>{{shareDevice}}台</span>
                  </div>
                  <div style="color: #C8C9CC;margin-top: 5px;font-size: 12px;">
                    <span>共享设备数</span>
                  </div>
                </div>
              </el-card>
            </div>
          </el-col>
          <el-col :span="4">
            <div v-if="isVender" @click="getUnknow">
              <el-card shadow="hover" style="border-top:3px solid #F5222D;">
                <div slot="header">
                  <span>设备</span>
                </div>
                <div>
                  <div style="font-size: 24px;">
                    <span>{{unknowDevice}}种</span>
                  </div>
                  <div style="color: red;margin-top: 5px;font-size: 12px;" v-if="unknowDevice>0">
                    <span>未知型号设备</span>
                  </div>
                  <div
                    style="color: #C8C9CC;margin-top: 5px;font-size: 12px;"
                    v-if="unknowDevice<=0"
                  >
                    <span>未知型号设备</span>
                  </div>
                </div>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </div>
      <div style="margin-top: 25px;">
        <div>
          <el-row :gutter="12">
            <el-col :span="8">
              <div>
                <div v-if="!isVender">
                  <el-button
                    type="primary"
                    icon="el-icon-share"
                    @click="share()"
                    v-if="isAdmin==1"
                  >授权</el-button>
                  <el-tooltip
                    class="item"
                    effect="light"
                    content="代理商员工只能查看自己被授权的设备"
                    placement="right-start"
                  >
                    <i class="el-icon-question" />
                  </el-tooltip>
                  <el-button type="primary" icon="el-icon-user" @click="openOwnerInfoDialog()">用户</el-button>
                  <el-tooltip
                    class="item"
                    effect="light"
                    content="绑定设备的终端用户"
                    placement="right-start"
                  >
                    <i class="el-icon-question" />
                  </el-tooltip>
                </div>
                <div v-if="isVender">
                  <el-button type="primary" icon="el-icon-user" @click="openDistributeDialog()">分配</el-button>
                  <el-tooltip
                    class="item"
                    effect="light"
                    content="只限库存和线下设备分配给代理商"
                    placement="right-start"
                  >
                    <i class="el-icon-question" />
                  </el-tooltip>
                  <el-button v-if="curAppid==19987658" type="primary" icon="el-icon-user" @click="openOwnerInfoDialog()">用户</el-button>
                  <el-tooltip
                    v-if="curAppid==19987658"
                    class="item"
                    effect="light"
                    content="绑定设备的终端用户"
                    placement="right-start">
                    <i class="el-icon-question" />
                  </el-tooltip>
                </div>
              </div>
            </el-col>
            <el-col :span="16">
              <div style="text-align: right;">
                <el-select
                  v-model="onlineCode"
                  @change="updateTable"
                  style="width: 130px;margin-left: 5px;"
                >
                  <el-option value="-1" label="全部"></el-option>
                  <el-option value="1" label="在线"></el-option>
                  <el-option value="0" label="离线"></el-option>
                </el-select>
                <el-select
                  v-model="leaseType"
                  style="width: 130px;margin-left: 5px;"
                  v-if="isVender"
                  @change="updateTable"
                >
                  <el-option value="-1" label="计费方式"></el-option>
                  <el-option value="0" label="租赁"></el-option>
                  <el-option value="1" label="共享"></el-option>
                  <el-option value="4" label="共享(发展程度)"></el-option>
                  <el-option value="2" label="售出"></el-option>
                  <el-option value="19" label="按桶租赁"></el-option>
                  <el-option value="20" label="按天租赁"></el-option>
                  <el-option value="3" label="库存"></el-option>
                </el-select>
                <el-select style="width: 150px;" v-model="selectValue" placeholder="请选择">
                  <el-option v-for="item in selectData" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <el-input
                  type="text"
                  style="width:255px;margin-left: 3px;"
                  v-model="queryValue"
                  v-if="isInput"
                  placeholder="请输入"
                ></el-input>
                <el-date-picker
                  style="width: 255px;margin-left: 3px;"
                  v-if="!isInput"
                  v-model="time"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="激活开始日期"
                  end-placeholder="激活结束日期"
                  format="yyyy-MM-dd"
                ></el-date-picker>
                <el-button
                  type="primary"
                  style="margin-left: 3px;"
                  icon="el-icon-search"
                  @click="updateTable"
                >搜索</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
        <div style="margin-top: 15px;">
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            element-loading-text="数据正在加载中"
            @selection-change="handleSelectionChange"
            :header-cell-style="headClass"
            :row-style="rowClass"
          >
            <el-table-column type="selection" width="60"></el-table-column>
            <el-table-column prop="sn" label="设备序列号" width="150">
              <template slot-scope="scope">
                <el-link
                  type="primary"
                  v-if="scope.row.ntId==1024||scope.row.ntId==1106"
                  @click="$router.push(`/deviceManagement/waterPurifierDetail?nid=${scope.row.nid}&sn=${scope.row.sn}`)"
                >{{ scope.row.sn }}</el-link>
                <span v-else>{{ scope.row.sn }}</span>
              </template>
            </el-table-column>
            <!--sortable-->
            <!-- <el-table-column prop="nickname" label="设备名称"></el-table-column> -->
            <el-table-column prop="rentStatus" label="计费方式" v-if="isVender">
              <template slot-scope="scope">
                <span v-if="scope.row.rentStatus === 0">租赁</span>
                <span v-if="scope.row.rentStatus === 1">共享</span>
                <span v-if="scope.row.rentStatus === 4">共享(发展程度)</span>
                <span v-if="scope.row.rentStatus === 2">售出</span>
                <span v-if="scope.row.rentStatus === 19">按桶租赁</span>
                <span v-if="scope.row.rentStatus === 20">按天租赁</span>
                <span v-if="scope.row.rentStatus === 21">线下</span>
                <span v-if="scope.row.rentStatus === 3">库存</span>
              </template>
            </el-table-column>
            <el-table-column prop="model" label="设备型号"></el-table-column>
            <el-table-column prop="name" label="代理商"></el-table-column>
            <el-table-column prop="endUserNickname" label="用户"></el-table-column>
            <!-- <el-table-column prop="fullAddress" label="用户地址"></el-table-column> -->
            <el-table-column prop="activationDate" label="激活日期" :formatter="dateFormat"></el-table-column>
            <el-table-column prop="expires" label="实际到期日期" :formatter="expiresDateFormat"></el-table-column>
            <el-table-column prop="expires" label="剩余天数" :formatter="countDays" align="center"></el-table-column>
            <el-table-column prop="expiresForDisplay" label="显示到期日期" :formatter="expiresDateFormat"></el-table-column>
            <el-table-column prop="lockMark" label="设备状态">
              <template slot-scope="scope">
                <span>{{deviceStatusDesc(scope.row)}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="lockMark" label="网络信号">
              <template slot-scope="scope">
                <span v-if="scope.row.online">在线</span>
                <span v-if="!scope.row.online">离线</span>
              </template>
            </el-table-column>
            <el-table-column prop="simExpiryDate" label="物联卡到期" :formatter="expiresDateFormat"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <button @click="openDialogVisible(scope.row)">操作</button>
                <!-- <button @click="openResetDialog(scope.row)">重置历史</button> -->
              </template>
            </el-table-column>
            <el-table-column label="更多">
              <template slot-scope="scope">
                <button @click="renewal(scope.row)" v-if="!isVender&&scope.row.rentStatus==0">续期</button>
                <button
                  @click="renewalByDay(scope.row)"
                  v-if="!isVender&&scope.row.rentStatus==20"
                >续期</button>
                <button
                  @click="deviceUnlock(scope.row)"
                  v-if="role=='4'&&scope.row.lockMark&&scope.row.ntId!=1033"
                >解锁</button>
                <button
                  @click="deviceLock(scope.row)"
                  v-if="role=='4'&&!scope.row.lockMark&&calTime(scope.row.expires)&&scope.row.ntId!=1033"
                >锁定</button>
                <button
                  @click="$router.push(`/deviceManagement/waterPurifierDetail?nid=${scope.row.nid}&sn=${scope.row.sn}`)"
                  v-if="scope.row.ntId==1024||scope.row.ntId==1106||scope.row.ntId==1030"
                >详情</button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            style="text-align:right;margin-top: 15px;margin-bottom: 55px;"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 50, 100, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <div v-show="!isFirst">
      <div style="margin-top: 20px;">
        <el-row :gutter="12">
          <el-col :span="8">
            <i class="el-icon-back" style="font-size: 16px;cursor:pointer;" @click="goback">未知型号设备</i>
          </el-col>
          <el-col :span="16">
            <div style="text-align: right;">
              <el-select style="width: 110px;" v-model="unknowSelectValue" placeholder="请选择">
                <el-option value="1" label="设备条形码"></el-option>
                <el-option value="2" label="导入时间"></el-option>
              </el-select>
              <el-input
                type="text"
                style="width:255px;margin-left: 3px;"
                v-model="unknowQueryValue"
                v-if="isUnknowInput"
                placeholder="请输入"
              ></el-input>
              <el-date-picker
                style="width: 255px;margin-left: 3px;"
                v-if="!isUnknowInput"
                v-model="unknowTime"
                type="daterange"
                range-separator="至"
                start-placeholder="激活开始日期"
                end-placeholder="激活结束日期"
                format="yyyy-MM-dd"
              ></el-date-picker>
              <el-button
                type="primary"
                style="margin-left: 3px;"
                icon="el-icon-search"
                @click="initTable()"
              >搜索</el-button>
              <el-button
                type="primary"
                style="margin-left: 3px;"
                icon="el-icon-edit"
                @click="singleModelSet=false;setModel()"
              >型号设置</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div style="margin-top: 25px;">
        <el-table
          ref="unknowTable"
          :data="unknowData"
          style="width: 100%"
          element-loading-text="数据正在加载中"
          @selection-change="unknowSelectionChange"
          :header-cell-style="headClass"
          :row-style="rowClass"
        >
          <el-table-column type="selection" width="60"></el-table-column>
          <el-table-column prop="sn" label="设备条形码"></el-table-column>
          <el-table-column prop="postTime" label="设备导入日期" :formatter="dateFormat"></el-table-column>
          <el-table-column prop="rentStatus" label="类型">
            <template slot-scope="scope">
              <span>{{ntIdDesc(scope.row.ntId)}}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          style="text-align:right;margin-top: 15px;margin-bottom: 55px;"
          @size-change="unknowSizeChange"
          @current-change="unknowCurrentChange"
          :current-page="unknowPage"
          :page-sizes="[10, 50, 100, 200]"
          :page-size="unknowSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="unknowTotal"
        ></el-pagination>
      </div>
    </div>
    <el-dialog :visible.sync="unLockDialogVisible" title="解锁" width="30%">
      <el-form>
        <el-form-item>
          <el-input placeholder="解锁天数(不能超过7天)" v-model="unLockDialogData.days" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="unLockDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitUnlockDevice">提 交</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="detailsVisible" :title="curRow.sn+' 详情'" width="45%">
      <table class="el-table" style="border-bottom: 0px;font-size:13px">
        <tr>
          <td class="detailtd">总用水量</td>
          <td>{{detailsData.allWaterFlow}}</td>
          <td class="detailtd">总净水量</td>
          <td>{{detailsData.totalWater}}</td>
        </tr>
        <tr>
          <td class="detailtd">TDS1</td>
          <td>{{detailsData.tdsValuesObj[0]}}</td>
          <td class="detailtd">TDS2</td>
          <td>{{detailsData.tdsValuesObj[1]}}</td>
        </tr>
        <tr v-for="(item,index) in detailsData.filterNamesObj" v-if="index%2==0" :key="item">
          <td
            class="detailtd"
            style="border-bottom: 0px;"
          >滤芯{{detailsData.filterNamesObj[index]}}寿命时长</td>
          <td
            style="border-bottom: 0px;"
          >{{(detailsData.filterEndTimesObj[index]/86400).toFixed(0)}}天({{detailsData.filterRunTimesObj[index]>=detailsData.filterEndTimesObj[index]?0:100-(detailsData.filterRunTimesObj[index]/detailsData.filterEndTimesObj[index]).toFixed(2)*100}}%)</td>
          <td
            class="detailtd"
            style="border-bottom: 0px;"
          >滤芯{{detailsData.filterNamesObj[index+1]}}寿命时长</td>
          <td
            style="border-bottom: 0px;"
          >{{(detailsData.filterEndTimesObj[index+1]/86400).toFixed(0)}}天({{detailsData.filterRunTimesObj[index+1]>=detailsData.filterEndTimesObj[index+1]?0:100-(detailsData.filterRunTimesObj[index+1]/detailsData.filterEndTimesObj[index+1]).toFixed(2)*100}}%)</td>
        </tr>
      </table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="openResetDialog()">重置历史</el-button>
        <el-button @click="detailsVisible = false">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="操作" :visible.sync="dialogVisible" width="500px" :before-close="handleClose">
      <el-button type="primary" style="margin: 5px;width:100px" @click="setNickname(nid)">昵称设置</el-button>
      <el-button
        type="primary"
        style="margin: 5px;width:100px"
        @click="singleModelSet=true;setModel();"
        v-if="isVender&&(curRow.rentStatus==3||curRow.rentStatus==21)"
      >型号设置</el-button>
      <el-button
        type="primary"
        style="margin: 5px;width:100px"
        @click="permanentUnlockAndRefund(nid);"
        v-if="isVender&&curRow.rentStatus==0&&curRow.userDeviceStatus==3"
      >延期退费</el-button>
      <span v-if="ntId==1024">
        <el-button
          type="primary"
          style="margin: 5px;width:100px"
          @click="pause(curRow.nid,true)"
          v-if="isVender&&curRow.userDeviceStatus==3"
        >暂停租赁</el-button>
        <el-button
          type="primary"
          style="margin: 5px;width:100px"
          @click="pause(curRow.nid,false)"
          v-if="isVender&&curRow.userDeviceStatus==7"
        >恢复租赁</el-button>
        <el-button
          type="primary"
          style="margin: 5px;width: 100px;"
          @click="openSecondUnlockDialog(curRow.nid, curRow.expires)"
        >二次解锁</el-button>
        <el-button
          type="primary"
          style="margin: 5px;width: 100px;"
          v-if="isVender"
          @click="permanentUnlock(curRow.nid)"
        >无限延期</el-button>
      </span>
      <span v-if="ntId==1030">
        <el-button
          type="primary"
          style="margin: 5px;width: 100px;"
          @click="openSecondUnlockDialog(curRow.nid, curRow.expires)"
        >二次解锁</el-button>
      </span>
      <span v-if="ntId==1033">
        <el-button
          type="primary"
          style="margin: 5px;width:130px"
          @click="setting(nid,2101)"
          v-if="isVender"
        >设置水容量</el-button>
        <el-button
          type="primary"
          style="margin: 5px;width:130px"
          @click="setting(nid,2102)"
          v-if="isVender&&type==1"
        >设置共享水容量</el-button>
        <el-button
          type="primary"
          style="margin: 5px;width:130px"
          @click="setting(nid,2104)"
          v-if="isVender&&type==0"
        >设置租赁水容量</el-button>
        <el-button
          type="primary"
          style="margin: 5px;width:130px"
          @click="operateShampoo(nid,2001)"
          v-if="isVender"
        >开启GAS</el-button>
        <el-button
          type="primary"
          style="margin: 5px;width:130px"
          @click="operateShampoo(nid,2002)"
          v-if="isVender"
        >关闭GAS</el-button>
        <el-button
          type="primary"
          style="margin: 5px;width:130px"
          @click="operateShampoo(nid,2003)"
          v-if="isVender"
        >开启淋浴</el-button>
        <el-button
          type="primary"
          style="margin: 5px;width:130px"
          @click="operateShampoo(nid,2004)"
          v-if="isVender"
        >关闭淋浴</el-button>
        <el-button
          type="primary"
          style="margin: 5px;width:130px"
          @click="operateShampoo(nid,2005)"
          v-if="isVender"
        >夏天模式</el-button>
        <el-button
          type="primary"
          style="margin: 5px;width:130px"
          @click="operateShampoo(nid,2006)"
          v-if="isVender"
        >冬天模式</el-button>
        <el-button
          type="primary"
          style="margin: 5px;width:130px"
          @click="operateShampoo(nid,2006)"
          v-if="isVender"
        >气体检测</el-button>
        <el-button
          type="primary"
          style="margin: 5px;width:130px"
          @click="setOperatingModel(nid, 1)"
          v-if="isVender"
        >共享模式</el-button>
        <el-button
          type="primary"
          style="margin: 5px;width:130px"
          @click="setOperatingModel(nid, 2)"
          v-if="isVender"
        >租赁模式</el-button>
        <el-button
          type="primary"
          style="margin: 5px;width:130px"
          @click="setOperatingModel(nid, 3)"
          v-if="isVender"
        >买断模式</el-button>
      </span>
      <el-button
        v-if="showDebugLog"
        type="primary"
        style="margin: 5px;width:100px"
        @click="openLogDialog(curRow.nid)"
      >调试日志</el-button>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
        <!--  <el-button type="primary" @click="dialogVisible = false">确 定</el-button>-->
      </span>
    </el-dialog>
    <el-dialog :visible.sync="setModelDialogVisible" title="设备型号设置" width="30%">
      <el-form>
        <el-form-item>
          型号设为：
          <el-select style="width: 110px;" v-model="selectedMid" placeholder="请选择">
            <el-option v-for="item in selectModelData" :label="item.name" :value="item.mid"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="setModelDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateModel">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="curRow.sn+' 重置历史'" :visible.sync="resetDialogVisible">
      <el-table :data="resetLogsData">
        <el-table-column prop="posttime" label="日期" :formatter="dateFormat"></el-table-column>
        <el-table-column prop="nickname" label="操作人"></el-table-column>
        <el-table-column prop="remark" label="涉及滤芯"></el-table-column>
        <el-table-column label="执行状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 0">下发指令</span>
            <span v-if="scope.row.status === 1">成功</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        style="text-align:right;margin-top: 15px;margin-bottom: 55px;"
        @current-change="resetCurrentChange"
        :current-page="resetPage"
        :page-size="10"
        layout="total, prev, pager, next"
        :total="resetTotal"
      ></el-pagination>
    </el-dialog>
    <el-dialog
      width="80%"
      :visible.sync="logDialogVisible"
      title="设备调试信息"
      :close-on-click-modal="false"
      ref="main"
    >
      <div class="log-div">
        <div style="overflow:auto;height: 90%" ref="main">
          <div id="messageList" ref="content"></div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      width="30%"
      :visible.sync="secondUnlockDialog"
      title="二次解锁"
      :close-on-click-modal="false"
    >
      <div style="margin-bottom: 20px;">
        <span>设备实际过期时间： {{ getStandardDate(new Date(secondUnlockExpireTime)) }}</span>
      </div>
      <span>请输入解锁天数：</span>
      <el-input v-model="secondUnlock.days" style="width: 130px"></el-input>
      <div slot="footer">
        <el-button @click="submitSecondUnlock" type="primary">确定</el-button>
        <el-button @click="secondUnlockDialog = false">取消</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="distributeVisible" title="分配给" width="30%">
      <el-form>
        <el-form-item>
          代理商：
          <el-select v-model="distributeAgent" style="width: 260px;" filterable>
            <el-option
              :value="item.agentId"
              :label="item.companyName"
              style="height: 40px;font-size: 11px;"
              v-for="item in companyList"
            >
              <el-row style="height: 20px;font-size: 10px;">
                <el-col :span="24" style="line-height: 20px;height: 20px;">{{item.companyName}}</el-col>
              </el-row>
              <el-row style="height: 20px;">
                <el-col :span="8" style="line-height: 20px;height: 20px;">{{item.name}}</el-col>
                <el-col :span="16" style="line-height: 20px;height: 20px;">{{item.phone}}</el-col>
              </el-row>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="distributeVisible = false">取 消</el-button>
        <el-button type="primary" @click="distribute()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      width="28%"
      :visible.sync="ownerInfoDialog"
      title="设置用户信息"
      :close-on-click-modal="false"
    >
      <el-form
        label-position="right"
        label-width="80px"
        :model="ownerInfoForm"
        ref="ownerInfoForm"
        :rules="rulesForOwnerInfoForm"
      >
        <el-form-item label="手机：" prop="phone">
          <el-input v-model="ownerInfoForm.phone" style="width:80%" :validate-event="false"></el-input>
        </el-form-item>
        <el-form-item label="姓名：" prop="name">
          <el-input v-model="ownerInfoForm.name" style="width:80%"></el-input>
        </el-form-item>
        <el-form-item label="地址：" prop="fullAddress">
          <el-input type="textarea" :rows="3" v-model="ownerInfoForm.fullAddress" style="width:80%"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="submitOwnerInfoFrom" type="primary">确定</el-button>
          <el-button @click="ownerInfoDialog = false">取消</el-button>
        </el-form-item>
      </el-form>
      <!-- <div slot="footer">
            <el-button @click="submitSecondUnlock" type="primary" >确定</el-button>
            <el-button @click="ownerInfoDialog = false">取消</el-button>
      </div>-->
    </el-dialog>

    <!--  按天续费弹窗  -->
    <el-dialog :visible.sync="renewalVisible" title="续费" width="28%" :close-on-click-modal="false">
      <el-row style="margin-bottom:25px">
        <el-col :span="12">序列号: {{renewalData.sn}}</el-col>
        <el-col :span="12">型号：{{ renewalData.model}}</el-col>
      </el-row>
      <el-row style="margin-bottom: 10px">
        <el-col :span="8">
          <el-button type="primary" style="width:100px" @click="renewalData.day=7">7天</el-button>
        </el-col>
        <el-col :span="8">
          <el-button type="primary" style="width:100px" @click="renewalData.day=30">一个月</el-button>
        </el-col>
        <el-col :span="8">
          <el-button type="primary" style="width:100px" @click="renewalData.day=365">一年</el-button>
        </el-col>
      </el-row>
      <el-row style="margin-bottom: 18px;text-align:right">
        <el-col :span="23">
          <el-input v-model="renewalData.day" style="width: 60%" type="number">
            <i slot="suffix" style="font-style:normal;">天</i>
          </el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="23" style="text-align: right;margin-bottom: 10px;">
          <strong style="font-size:large">
            合计：
            <span style="color: orange;">{{Number(renewalData.day*renewalData.price).toFixed(2)}}</span>元
          </strong>
        </el-col>
      </el-row>
      <el-button
        type="primary"
        style="margin: 5px;width:95%; align-self: center"
        @click="submitRenewal"
      >续费</el-button>
    </el-dialog>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import axios from 'axios'
import {
  vxRule
} from '@/utils/validator';
import {
  request
} from '@/utils/request'
var ws;

export default {
  name: 'deviceOverview',
  components: {},
  data () {
    return {
      showDebugLog: true,
      resetPage: 1,
      resetTotal: 0,
      nid: 0,
      ntId: 0,
      totalDevice: 0,
      leaseDevice: 0,
      buyoutDevice: 0,
      shareDevice: 0,
      unknowDevice: 0,
      isVender: false,
      leaseType: '-1',
      onlineCode: '-1',
      optionMethod: "",
      selectData: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      queryValue: '',
      unknowQueryValue: '',
      selectValue: '',
      unknowSelectValue: '',
      multipleSelection: [],
      tableData: [],
      unknowTotal: 0,
      unknowPage: 1,
      unknowSize: 10,
      unknowSelection: [],
      unknowData: [],
      resetLogsData: [],
      time: [],
      unknowTime: [],
      isFirst: true,
      role: '0',
      isAdmin: 0,
      unLockDialogVisible: false,
      unLockDialogData: {
        row: {},
        days: ''
      },
      detailsVisible: false,
      detailsData: {
        "filterNamesObj": [],
        "tdsValuesObj": [0, 0]
      },
      curRow: {},
      timerId: "",
      checkTimes: 0,
      dialogVisible: false,
      setModelDialogVisible: false,
      resetDialogVisible: false,
      logDialogVisible: false,
      type: 0,
      selectedMid: '',
      selectModelData: [],
      singleModelSet: false,
      secondUnlock: {
        nid: '',
        days: '',
      },
      secondUnlockDialog: false,
      secondUnlockExpireTime: 0,
      renewalVisible: false,
      renewalData: {
        day: 0,
        sn: '',
        skuId: -1,
        model: '',
        price: 0.0,
        propertiesName: '',
        image: ''
      },
      ownerInfoDialog: false,
      ownerInfoForm: {
        phone: '',
        name: '',
        fullAddress: ''
      },
      rulesForOwnerInfoForm: {
        phone: vxRule(true, "Mobile", null),
        fullAddress: [{
          max: 100,
          message: '长度不能超过100个字符',
          trigger: 'blur'
        }]
      },
      distributeVisible: false,
      companyList: [],
      distributeAgent: ''
    }
  },
  watch: {
    logDialogVisible (val) {
      console.log(val)
      if (!val) {
        this.closeWebSocket();
      }
    }
  },
  computed: {
    isInput: function () {
      if (this.selectValue != '5') {
        this.queryValue = ''
        return true
      } else {
        return false
      }
    },
    isUnknowInput: function () {
      if (this.unknowSelectValue != '2') {
        this.unknowQueryValue = '';
        return true
      } else {
        return false
      }
    }
  },
  mounted () {
    var thiz = this
    axios
      .get(this.$store.getters.getApiValue + '/srsUser/getMyData.do')
      .then(function (response) {
        var data = response.data
        thiz.role = data.data.role
        thiz.isAdmin = data.data.isAdmin
        if (data.status == '200') {
          thiz.selectData = [{
            label: '设备条形码',
            value: '1'
          },
          {
            label: '设备型号',
            value: '2'
          },
          {
            label: '用户',
            value: '3'
          },
          {
            label: '激活日期',
            value: '5'
          },
          {
            label: '剩余天数',
            value: '6'
          },
          {
            label: '开单号',
            value: '7'
          }, {
            label: '物联卡几天内到期',
            value: '8'
          }
          ]
          if (data.data.role == '4') {
            thiz.isVender = true
            var item = {
              label: '代理商',
              value: '4'
            }
            thiz.selectData.push(item)
          }
          thiz.initPage()
          thiz.updateTable()
        } else {
          thiz.$message.error(data.message)
        }
      })
      .catch(function (error) {
        console.log(error)
        thiz.$message.error('系统异常,请与管理员联系!')
      });
    this.listAgent();
    if (Cookies.get("srs_nickname") == 19987658) {
      //因为泽蛙开了cdn加速，无法使用socket通讯
      this.showDebugLog = false;
    }
    this.curAppid=this.$store.getters.appid;
  },
  beforeDestroy () { },
  methods: {
    ntIdDesc (ntId) {
      if (ntId == 1024) {
        return "商用净水器"
      } else if (ntId == 1030) {
        return "家用净水器";
      } else if (ntId == 1033) {
        return "洗头机";
      } else if (ntId == 1106) {
        return "全屋纯水机";
      }
    },
    deviceStatusDesc (row) {
      if (row.userDeviceStatus == 10) {
        return "销机"
      }
      if (row.lockMark) {
        return "锁定";
      } else {
        if (row.status) {
          return "正常";
        } else {
          return "关机";
        }
      }
    },
    filterStatus (status) {
      let result = "";
      if (status == 3) {
        result = "优";
      } else if (status == 2) {
        result = "良";
      } else if (status == 1) {
        result = "差";
      }
      return result;
    },
    share () {
      if (this.multipleSelection.length == 0) {
        this.$message.warning("请选择操作的设备");
        return;
      }
      this.$prompt('请输入手机号', '授权', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^1\d{10}$/,
        inputErrorMessage: '手机格式不正确'
      }).then(({
        value
      }) => {
        let nids = "";
        this.multipleSelection.forEach(element => {
          nids = nids + ',' + element.nid;
        });
        nids = nids.substring(1);
        request({
          url: '/srsDevice/share.do',
          method: 'get',
          params: {
            nids: nids,
            phone: value
          }
        }).then(res => {
          if (res.data) {
            this.$message.success('设置成功！');
          }
        })
      })
    },
    openDistributeDialog () {
      if (this.multipleSelection.length == 0) {
        this.$message.warning("请选择操作的设备");
        return;
      }
      this.distributeVisible = true;
    },
    openOwnerInfoDialog () {
      if (this.multipleSelection.length == 0) {
        this.$message.warning("请选择操作的设备");
        return;
      }
      this.$nextTick(() => {
        if (this.$refs['ownerInfoForm'] !== undefined) {
          this.$refs['ownerInfoForm'].resetFields();
        }
      });
      this.ownerInfoDialog = true;
    },
    submitOwnerInfoFrom () {
      var thiz = this;
      this.$refs.ownerInfoForm.validate((valid) => {
        if (valid) {
          let nids = "";
          this.multipleSelection.forEach(element => {
            nids = nids + ',' + element.nid;
          });
          nids = nids.substring(1);
          request({
            url: '/srsDevice/setOwner.do',
            method: 'get',
            params: {
              nids: nids,
              phone: thiz.ownerInfoForm.phone,
              name: thiz.ownerInfoForm.name,
              fullAddress: thiz.ownerInfoForm.fullAddress
            }
          }).then(res => {
            if (res.data) {
              thiz.$message.success('设置成功！');
              thiz.updateTable();
              thiz.ownerInfoDialog = false;
            }
          })
        }
      })
    },
    permanentUnlockAndRefund (nid) {
      var thiz = this
      this.$confirm(
        '该操作会退还未使用的服务费，并且永久解锁设备，请在明确其意义后再谨慎操作'
      )
        .then(_ => {
          axios
            .get(this.$store.getters.getApiValue + '/application/permanentUnlockAndRefund.do', {
              params: {
                nid: nid
              }
            })
            .then(function (response) {
              var data = response.data
              if (data.status == '200') {
                thiz.$message.success('操作成功!');
                thiz.updateTable();
              } else {
                thiz.$message.error(data.message)
              }
            })
            .catch(function (error) {
              console.log(error)
              thiz.$message.error('系统异常!请与管理员联系!')
            })
        })
        .catch(_ => { })
    },
    permanentUnlock (nid) {
      var thiz = this
      this.$confirm(
        '该操作会导致设备不再之前的商业模式逻辑，并且永久解锁设备，请在明确其意义后再谨慎操作'
      )
        .then(_ => {
          const loading = this.$loading({
            lock: true,
            text: '执行中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          axios
            .get(this.$store.getters.getApiValue + '/application/permanentUnlock.do', {
              params: {
                nid: nid
              }
            })
            .then(function (response) {
              loading.close()
              var data = response.data
              if (data.status == '200') {
                thiz.$message.success('操作成功!');
                thiz.updateTable();
              } else {
                thiz.$message.error(data.message)
              }
            })
            .catch(function (error) {
              loading.close()
              console.log(error)
              thiz.$message.error('系统异常!请与管理员联系!')
            })
        })
        .catch(_ => { })
    },
    pause (nid, isPayse) {
      var thiz = this;
      axios
        .get(this.$store.getters.getApiValue + (isPayse ? "/application/pause.do" :
          "/application/carryOn.do"), {
          params: {
            nid: nid
          }
        })
        .then(function (response) {
          var data = response.data
          if (data.status == '200') {
            thiz.$message.success('操作成功!');
            thiz.updateTable();
          } else {
            thiz.$message.error(data.message)
          }
        })
        .catch(function (error) {
          console.log(error)
          thiz.$message.error('系统异常!请与管理员联系!')
        })
    },
    setNickname (nid) {
      var thiz = this;
      this.$prompt('请输入新设备名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
        inputErrorMessage: '不能为空'
      }).then(({
        value
      }) => {
        axios
          .get(this.$store.getters.getApiValue + '/srsDevice/updateNickname.do', {
            params: {
              nid: nid,
              nickname: value
            }
          })
          .then(function (response) {
            var data = response.data
            if (data.status == '200') {
              thiz.$message.success('设置成功!');
              thiz.updateTable();
            } else {
              thiz.$message.error(data.message)
            }
          })
          .catch(function (error) {
            console.log(error)
            thiz.$message.error('系统异常!请与管理员联系!')
          })
      }).catch(() => {

      });
    },
    openResetDialog () {
      this.resetPage = 1;
      this.resetTotal = 0;
      this.resetDialogVisible = true;
      this.resetLogsTable();
    },
    setModel () {
      var thiz = this;
      var curNtid;
      if (thiz.singleModelSet) {
        curNtid = this.curRow.ntId;
      } else {
        if (this.unknowSelection.length < 1) {
          this.$message.error("请勾选待操作设备");
          return false;
        }
        curNtid = this.unknowSelection[0].ntId;
        this.unknowSelection.forEach(element => {
          if (element.ntId != curNtid) {
            this.$message.error("只支持同一类型的设备进行批量设置型号");
            return false
          }
        });
      }
      axios
        .get(this.$store.getters.getApiValue + '/equipmentModel/list.do', {
          params: {
            ntId: curNtid
          }
        })
        .then(function (response) {
          var data = response.data
          if (data.status == '200') {
            thiz.selectModelData = data.data;
            thiz.setModelDialogVisible = true;
          } else {
            thiz.$message.error(data.message)
          }
        })
        .catch(function (error) {
          console.log(error)
          thiz.$message.error('系统异常!请与管理员联系!')
        })

    },
    updateModel () {
      var thiz = this;
      if (this.selectedMid == '') {
        thiz.$message.error('请选择型号');
        return false;
      }
      var nids = "";
      if (this.singleModelSet) {
        nids = this.curRow.nid;
      } else {
        this.unknowSelection.forEach(element => {
          nids = nids + ',' + element.nid;
        });
        nids = nids.substring(1);
      }
      axios
        .get(this.$store.getters.getApiValue + '/srsDevice/setMid.do', {
          params: {
            nids: nids,
            mid: thiz.selectedMid
          }
        })
        .then(function (response) {
          var data = response.data
          if (data.status == '200') {
            thiz.$message.success('设置成功!')
            thiz.setModelDialogVisible = false;
            if (thiz.singleModelSet) {
              thiz.updateTable();
            } else {
              thiz.initTable();
            }
          } else {
            thiz.$message.error(data.message)
          }
        })
        .catch(function (error) {
          console.log(error)
          thiz.$message.error('系统异常!请与管理员联系!')
        })

    },
    ctrlCheck (msgidList, loading) {
      var thiz = this;
      thiz.checkTimes++;
      if (thiz.checkTimes > 3) {
        thiz.$message.error("执行超时");
        clearInterval(thiz.timerId);
        loading.close();
        return false;
      }
      axios
        .get(this.$store.getters.getApiValue + '/srsDevice/ctrlCheck.do', {
          params: {
            msgidList: msgidList
          }
        })
        .then(function (response) {
          var data = response.data
          if (data.status == '200' && data.data == 1) {
            thiz.$message.success('执行成功!')
            clearInterval(thiz.timerId);
            loading.close();
          } else {
            console.info("轮询结果失败");
          }
        })
        .catch(function (error) { })
    },
    optionChange (nid, action) {
      var thiz = this
      if (this.multipleSelection.length < 1 && nid == 0) {
        this.$message.error("请勾选待操作设备");
        thiz.optionMethod = "";
        return false;
      }
      debugger
      var nids = "";
      /* for( var i=0;i<this.multipleSelection.length;i++){
           if(i>0){
               nids=nids+",";
           }
           nids=nids+this.multipleSelection[i].nid
       }*/
      nids = nid;
      const loading = this.$loading({
        lock: true,
        text: '操作执行中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      axios
        .get(this.$store.getters.getApiValue + '/smartWaterPurify/operate.do', {
          params: {
            nid: nids,
            action: action
          }
        })
        .then(function (response) {
          var data = response.data
          if (data.status == '200') {
            thiz.checkTimes = 0;
            thiz.timerId = setInterval(() => {
              thiz.ctrlCheck(data.data, loading)
            }, 3000);
          } else {
            loading.close()
            thiz.$message.error(data.message)
          }
        })
        .catch(function (error) {
          loading.close()
          console.log(error)
          thiz.$message.error('系统异常!请与管理员联系!')
        })
      thiz.optionMethod = "";
    },
    initPage () {
      var thiz = this
      axios
        .get(this.$store.getters.getApiValue + '/srsDevice/deviceOverview.do')
        .then(function (response) {
          var data = response.data
          if (data.status == '200') {
            thiz.totalDevice = data.data.totalDevice
            thiz.leaseDevice = data.data.leaseDevice
            thiz.buyoutDevice = data.data.buyoutDevice
            thiz.shareDevice = data.data.shareDevice
            thiz.unknowDevice = data.data.unknowDevice
          } else {
            thiz.$message.error(data.message)
          }
        })
        .catch(function (error) {
          console.log(error)
          thiz.$message.error('系统异常!请与管理员联系!')
        })
    },
    getMessage (row) {
      alert(row.nid)
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.updateTable()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.updateTable()
    },
    updateTable () {
      var thiz = this
      var params = {
        rentStatus: this.leaseType,
        online: this.onlineCode,
        pageId: this.currentPage,
        size: this.pageSize,
        timestamp: new Date().getTime()
      }
      if (this.selectValue != '') {
        if (this.selectValue == '1' && this.queryValue != '') {
          params.sn = this.queryValue
        } else if (this.selectValue == '2' && this.queryValue != '') {
          params.model = this.queryValue
        } else if (this.selectValue == '3' && this.queryValue != '') {
          params.uname = this.queryValue
        } else if (this.selectValue == '4' && this.queryValue != '') {
          params.agentName = this.queryValue
        } else if (this.selectValue == '5') {
          if (this.time != null && this.time.length > 0) {
            params.beginTime = this.getStandardDate(this.time[0])
            params.endTime = this.getStandardDate(this.time[1])
          }
        } else if (this.selectValue == '6' && this.queryValue != '') {
          if (this.queryValue < 0) {
            thiz.$message.error("请输入大于等于0的数字");
            return;
          }
          params.remainingDays = this.queryValue
        } else if (this.selectValue == '7' && this.queryValue != '') {
          params.applicationId = this.queryValue
        } else if (this.selectValue == '8' && this.queryValue != '') {
          if (this.queryValue <= 0 || this.queryValue > 60) {
            thiz.$message.error("请输入大于0且小于等于60的数字");
            return;
          }
          params.simDaysToExpiry = this.queryValue
        }
      }
      const loading = this.$loading({
        lock: true,
        text: '获取表格数据中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      setTimeout(() => {
        loading.close()
      }, 3000)
      axios
        .get(this.$store.getters.getApiValue + '/srsDevice/searchMyDevice.do', {
          params: params
        })
        .then(function (response) {
          loading.close()
          var data = response.data
          if (data.status == '200') {
            thiz.total = data.totalCount
            thiz.tableData = data.data
          } else {
            thiz.$message.error(data.message)
          }
        })
        .catch(function (error) {
          loading.close()
          console.log(error)
          thiz.$message.error('系统异常!请与管理员联系!')
        })
    },
    loadData () {
      var thiz = this
      const loading = this.$loading({
        lock: true,
        text: '正在导入设备，提示完成前请勿重复操作或者关闭页面',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      axios
        .get(this.$store.getters.getApiValue + '/srsDevice/importDevice.do')
        .then(function (response) {
          loading.close()
          var data = response.data
          if (data.status == '200') {
            thiz.$message.success('导入数据成功!')
            thiz.updateTable()
          } else {
            thiz.$message.error('导入数据失败!')
          }
        })
        .catch(function (error) {
          loading.close()
          console.log(error)
          thiz.$message.error('系统异常!请与管理员联系!')
        })
    },
    headClass ({
      row,
      rowIndex
    }) {
      if (rowIndex == 0) {
        // return ''
      }
      return ''
    },
    rowClass ({
      row,
      rowIndex
    }) {
      if (rowIndex % 2 == 0) {
        return 'background:#F1F2F7;'
      } else {
        return 'background:white;'
      }
      return ''
    },
    dateFormat (row, column, cellValue, index) {
      var str = cellValue
      if (str == null || str == '') {
        return ''
      } else {
        return this.getStandardDate(new Date(str))
      }
    },
    countDays (row, column, cellValue, index) {
      let days = Math.ceil((cellValue - (new Date().getTime())) / 86400000);
      if (days < 0) {
        days = 0;
      }
      return days;
    },
    expiresDateFormat (row, column, cellValue, index) {
      if (row.userDeviceStatus == 7) {
        return "剩余" + parseInt(row.leftTime / 3600) + "小时";
      }
      var str = cellValue
      if (str == null || str == '') {
        return ''
      } else {
        // let days = Math.ceil((cellValue - (new Date().getTime())) / 86400000);
        // if (days < 0) {
        //     days = 0;
        // }
        return this.getStandardDate(new Date(str))
      }
    },
    getStandardDate (val) {
      var year = val.getFullYear()
      var month = val.getMonth() + 1
      var day = val.getDate()
      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      return year + '-' + month + '-' + day
    },
    getUnknow () {
      this.isFirst = false
      this.initTable()
    },
    resetLogsTable () {
      var thiz = this;
      axios
        .get(
          this.$store.getters.getApiValue + '/smartWaterPurify/filterResetLogs.do', {
          params: {
            pageId: this.resetPage,
            size: 10,
            nid: this.curRow.nid
          }
        }
        )
        .then(function (response) {
          var data = response.data
          if (data.status == '200') {
            thiz.resetTotal = data.totalCount
            thiz.resetLogsData = data.data
          } else {
            thiz.$message.error(data.message)
          }
        })
        .catch(function (error) {
          console.log(error)
          thiz.$message.error('系统异常!请与管理员联系!')
        })
    },
    initTable () {
      var thiz = this
      var params = {
        pageId: this.unknowPage,
        size: this.unknowSize,
      }
      if (this.unknowSelectValue != '') {
        if (this.unknowSelectValue == '1' && this.unknowQueryValue != '') {
          params.sn = this.unknowQueryValue
        } else if (this.unknowSelectValue == '2') {
          if (this.unknowTime != null && this.unknowTime.length > 0) {
            params.beginTime = this.getStandardDate(this.unknowTime[0])
            params.endTime = this.getStandardDate(this.unknowTime[1])
          }
        }
      }
      const loading = this.$loading({
        lock: true,
        text: '导入表格数据中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      axios
        .get(
          this.$store.getters.getApiValue + '/srsDevice/getUnknowDevice.do', {
          params: params
        }
        )
        .then(function (response) {
          loading.close()
          var data = response.data
          if (data.status == '200') {
            thiz.unknowTotal = data.totalCount
            thiz.unknowData = data.data
          } else {
            thiz.$message.error(data.message)
          }
        })
        .catch(function (error) {
          loading.close()
          console.log(error)
          thiz.$message.error('系统异常!请与管理员联系!')
        })
    },
    goback () {
      this.initTable()
      this.isFirst = true
    },
    unknowSelectionChange (val) {
      console.log(val);
      this.unknowSelection = val
    },
    unknowSizeChange (val) {
      this.unknowSize = val
      this.initTable()
    },
    unknowCurrentChange (val) {
      this.unknowPage = val
      this.initTable()
    },
    resetCurrentChange (val) {
      this.resetPage = val
      this.resetLogsTable()
    },
    newProduct (row) {
      console.log(row)
    },
    renewal (row) {
      var thiz = this
      this.$confirm(
        '确认为客户' +
        row.companyName +
        '续期设备条形码为“' +
        row.sn +
        '”的设备吗?'
      )
        .then(_ => {
          const loading = this.$loading({
            lock: true,
            text: '续期中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          axios
            .get(
              thiz.$store.getters.getApiValue + '/srsDevice/deviceRenewal.do', {
              params: {
                nid: row.nid
              }
            }
            )
            .then(function (response) {
              var data = response.data
              if (data.status == '200') {
                if (data.data) {
                  thiz.$message.success(
                    '续期成功!数据有延迟，请在1分钟后刷新页面进行查看到期时间!'
                  )
                  setTimeout(() => {
                    loading.close()
                    thiz.updateTable()
                  }, 5000)
                } else {
                  thiz.$message.error('续期失败!')
                  loading.close()
                }
              } else {
                loading.close()
                thiz.$message.error(data.message)
              }
            })
            .catch(function (error) {
              console.log(error)
              loading.close()
              thiz.$message.error('系统异常!请与管理员联系!')
            })
        })
        .catch(_ => { })
    },
    renewalByDay (row) {
      const thiz = this
      this.renewalVisible = true;
      this.renewalData.model = row.model
      this.renewalData.sn = row.sn
      axios
        .get(this.$store.getters.getApiValue + '/product/getProductByDevice.do', {
          params: {
            sn: row.sn,
            cid: 20,
            queryJson: '[{"key":"charge_items","value":"1"}]'
          }
        })
        .then(function (response) {
          const data = response.data;
          if (data.status == '200') {
            thiz.renewalData.skuId = data.data.skuProductList[0].skuId
            thiz.renewalData.price = data.data.skuProductList[0].price
            thiz.renewalData.image = data.data.mainImage[0]
            thiz.renewalData.propertiesName = data.data.skuProductList[0].propertiesName
          } else {
            thiz.$message.error(data.message)
          }
        })
        .catch(function (error) {
          console.log(error)
          thiz.$message.error('系统异常!请与管理员联系!')
        })
    },
    details (row) {
      const thiz = this;
      this.curRow = row;
      axios
        .get(this.$store.getters.getApiValue + '/smartWaterPurify/getInfo.do', {
          params: {
            nid: row.nid
          }
        })
        .then(function (response) {
          var data = response.data
          if (data.status == '200') {
            console.info("接收的数据" + data.data)
            console.info(data)
            thiz.detailsData = data.data
            thiz.detailsData.tdsValuesObj = data.data.tdsValues != null ? JSON.parse(data.data
              .tdsValues) : [0, 0];
            thiz.detailsData.filterNamesObj = data.data.filterNames.split(","),
              thiz.detailsData.filterEndTimesObj = data.data.filterEndTimes != null ? JSON.parse(
                data.data.filterEndTimes) : [1, 1, 1, 1, 1];
            thiz.detailsData.filterRunTimesObj = data.data.filterRunTimes != null ? JSON.parse(data
              .data.filterRunTimes) : [1, 1, 1, 1, 1];
            thiz.detailsVisible = true
          } else {
            thiz.$message.error(data.message)
          }
        })
        .catch(function (error) {
          //loading.close()
          console.log(error)
          thiz.$message.error('系统异常!请与管理员联系!')
        })
    },
    deviceLock (row) {
      const thiz = this
      const loading = this.$loading({
        lock: true,
        text: '操作执行中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      axios
        .get(this.$store.getters.getApiValue + '/srsDevice/lock.do', {
          params: {
            nid: row.nid,
            sync: true
          }
        })
        .then(function (response) {
          loading.close()
          var data = response.data
          if (data.status == '200') {
            if (data.data == "success") {
              thiz.$message.success('操作成功！')
              thiz.updateTable()
            } else {
              thiz.$message.success('操作失败！')
              thiz.updateTable()
            }
          } else {
            thiz.$message.error(data.message)
          }
        })
        .catch(function (error) {
          loading.close()
          console.log(error)
          thiz.$message.error('系统异常!请与管理员联系!')
        })
    },
    deviceUnlock (row) {
      this.unLockDialogVisible = true
      this.unLockDialogData.row = row
    },
    calTime (time) {
      const currentTime = new Date().getTime()
      if (time && time > currentTime) {
        return false
      }
      return true
    },
    submitUnlockDevice () {
      const thiz = this
      // if (thiz.unLockDialogData.days > 7) {
      //     thiz.$message.error('手动解锁不能超过7天！');
      //     return false;
      // }
      this.unLockDialogVisible = false
      const loading = this.$loading({
        lock: true,
        text: '操作执行中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      axios
        .get(this.$store.getters.getApiValue + '/srsDevice/unlock.do', {
          params: {
            nid: thiz.unLockDialogData.row.nid,
            days: thiz.unLockDialogData.days,
            sync: true
          }
        })
        .then(function (response) {
          loading.close()
          var data = response.data
          if (data.status == '200') {
            if (data.data == "success") {
              thiz.$message.success('操作成功！')
              thiz.updateTable()
            } else {
              thiz.$message.success('操作失败！')
              thiz.updateTable()
            }
          } else {
            thiz.$message.error(data.message)
          }
        })
        .catch(function (error) {
          loading.close()
          console.log(error)
          thiz.$message.error('系统异常!请与管理员联系!')
        })
    },
    handleClose () {
      this.dialogVisible = false
    },
    openDialogVisible (row) {
      if (row.ntId == 1033) {
        axios
          .get(this.$store.getters.getApiValue + '/smartShampoo/get.do', {
            params: {
              nid: row.nid
            }
          }).then(res => {
            this.type = res.data.data.type
          })
      }

      this.dialogVisible = true
      this.nid = row.nid
      this.ntId = row.ntId
      this.curRow = row
    },
    operateShampoo (nid, type) {
      const loading = this.$loading({
        lock: true,
        text: '操作执行中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      var thiz = this
      axios
        .get(this.$store.getters.getApiValue + '/smartShampoo/operate.do', {
          params: {
            nid: nid,
            action: type,
            sync: false
          }
        })
        .then(function (response) {
          var data = response.data
          if (data.status == '200') {
            thiz.checkTimes = 0;
            thiz.timerId = setInterval(() => {
              thiz.ctrlCheck(data.data, loading)
            }, 3000);
          } else {
            loading.close()
            thiz.$message.error(data.message)
          }
        })
        .catch(function (error) {
          loading.close()
          console.log(error)
          thiz.$message.error('系统异常!请与管理员联系!')
        })
      // .then(function (response) {
      //     loading.close()
      //     var data = response.data
      //     console.log(data)
      //     if (data.status == '200') {
      //         if (data.data == "success") {
      //             thiz.$message.success('操作成功！')
      //             thiz.updateTable()
      //         } else {
      //             thiz.$message.error('操作失败！')
      //             thiz.updateTable()
      //         }
      //     } else {
      //         thiz.$message.error(data.message)
      //     }
      // })
      // .catch(function (error) {
      //     loading.close()
      //     console.log(error)
      //     thiz.$message.error('系统异常!请与管理员联系!')
      // })
    },
    setOperatingModel (nid, model) {
      const loading = this.$loading({
        lock: true,
        text: '操作执行中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      var thiz = this
      axios
        .get(this.$store.getters.getApiValue + '/smartShampoo/setParam.do', {
          params: {
            nid: nid,
            action: 2105,
            value: model,
            sync: false
          }
        })
        .then(function (response) {
          var data = response.data
          if (data.status == '200') {
            thiz.checkTimes = 0;
            thiz.timerId = setInterval(() => {
              thiz.ctrlCheck(data.data, loading)
            }, 3000);
          } else {
            loading.close()
            thiz.$message.error(data.message)
          }
        })
        .catch(function (error) {
          loading.close()
          console.log(error)
          thiz.$message.error('系统异常!请与管理员联系!')
        })
    },
    setting (nid, type) {
      this.$prompt('请输入设置的值', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
        /* inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
         inputErrorMessage: '邮箱格式不正确'*/
      }).then(({
        value
      }) => {
        const loading = this.$loading({
          lock: true,
          text: '操作执行中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        var thiz = this
        axios
          .get(this.$store.getters.getApiValue + '/smartShampoo/setParam.do', {
            params: {
              nid: nid,
              action: type,
              value: value,
              sync: true
            }
          })
          .then(function (response) {
            loading.close()
            var data = response.data
            if (data.status == '200') {
              if (data.data == "success") {
                thiz.$message.success('设置成功！')
                thiz.updateTable()
              } else {
                thiz.$message.error('设置失败！')
                thiz.updateTable()
              }
            } else {
              thiz.$message.error(data.message)
            }
          })
          .catch(function (error) {
            loading.close()
            console.log(error)
            thiz.$message.error('系统异常!请与管理员联系!')
          })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
      });
    },
    openLogDialog (nid) {
      this.logDialogVisible = true;
      this.getLogWebSocketConnect(nid);
    },
    getLogWebSocketConnect (nid) {
      var ishttps = 'https:' === document.location.protocol;
      var protocol = 'ws:';
      if (ishttps) {
        protocol = 'wss:'
      }
      var wsServer = `${protocol}//${window.location.host}/LogWebSocket.do?nid=${nid}`;
      ws = new WebSocket(wsServer);
      var thiz = this;
      ws.onopen = function (evt) {
        console.log("已经建立连接");
        console.log(evt)
      };
      ws.onmessage = function (evt) {
        document.getElementById('messageList').innerHTML +=
          `<p class="log-li">${thiz.getNowFormatDate()} ------- ${evt.data}</p>`
        thiz.$nextTick(() => {
          thiz.$refs.main.scrollTop = thiz.$refs.content.scrollHeight;
        });
        //console.log(evt, "链接evt");
      };
      ws.onerror = function (evt) {
        console.log(evt);
        console.log("产生异常");
      };
      ws.onclose = function (evt) {
        console.log(evt);
        console.log("已经关闭连接");
      };
    },
    closeWebSocket () {
      ws.close();
      document.getElementById('messageList').innerHTML = '';
    },
    getNowFormatDate () {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      var currentdate = year + seperator1 + month + seperator1 + strDate + ' ' + hours + ":" + minutes + ':' +
        seconds;
      return currentdate;
    },
    //  二次解锁

    openSecondUnlockDialog (nid, expiresDisplay) {
      this.secondUnlockDialog = true;
      this.secondUnlock.nid = nid;
      this.secondUnlock.days = '';
      this.secondUnlockExpireTime = expiresDisplay;
    },
    submitSecondUnlock () {
      const loading = this.$loading({
        lock: true,
        text: '操作执行中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      var thiz = this
      axios
        .get(this.$store.getters.getApiValue + '/srsDevice/secondUnlock.do', {
          params: thiz.secondUnlock
        })
        .then(function (response) {
          loading.close()
          var data = response.data
          if (data.status == '200') {
            if (data.data) {
              thiz.$message.success('设置成功！')
              thiz.updateTable()
            } else {
              thiz.$message.error('设置失败！')
              thiz.updateTable()
            }
          } else {
            thiz.$message.error(data.message)
          }
        })
        .catch(function (error) {
          loading.close()
          console.log(error)
          thiz.$message.error('系统异常!请与管理员联系!')
        })
      this.secondUnlockDialog = false;
    },
    submitRenewal () {
      const data = this.renewalData
      if (data.day <= 0) {
        this.$message.error("续费天数必须大于0")
        return
      }

      const thiz = this

      this.$confirm('是否继续支付延期?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = thiz.$loading({
          lock: true,
          text: '操作执行中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        axios
          .get(thiz.$store.getters.getApiValue + '/order/generate.do', {
            params: {
              skuId: data.skuId,
              quantity: data.day,
              propertiesName: data.propertiesName,
              image: data.image,
              sn: data.sn
            }
          })
          .then(function (response) {
            const data = response.data
            if (data.status == '200') {
              if (data.data) {
                thiz.orderPay(data.data)
                loading.close();
              } else {
                thiz.$message.error('订单错误!请与管理员联系!')
                loading.close();
              }
            } else {
              thiz.$message.error(data.message);
              loading.close();
            }
          })
          .catch(function (error) {
            loading.close()
            console.log(error)
            thiz.$message.error('系统异常!请与管理员联系!')
          })
      }).catch(() => { });
    },
    orderPay (orderId, loading) {
      const thiz = this
      axios
        .get(this.$store.getters.getApiValue + '/order/pay.do', {
          params: {
            orderId: orderId
          }
        })
        .then(function (response) {
          thiz.renewalVisible = false
          const data = response.data
          if (data.status == '200') {
            thiz.$message.success('续费成功，数据有延迟，请在1分钟后刷新页面进行查看到期时间')
          } else {
            thiz.$message.error('续费失败')
          }
        })
        .catch(function (error) {
          thiz.renewalVisible = false
          console.log(error)
          thiz.$message.error('系统异常!请与管理员联系!')
        })
    },
    listAgent () {
      console.log('获取代理商列表');
      var thiz = this;
      axios.get(this.$store.getters.getApiValue + '/srsAgent/getAllAgentList.do')
        .then(function (response) {
          var data = response.data;
          if (data.status == "200") {
            thiz.companyList = data.data;
          } else {
            thiz.$message.error(data.message);
          }
        }).catch(function (error) {
          console.log(error);
        });
    },
    distribute () {
      var thiz = this;
      let nids = "";
      this.multipleSelection.forEach(element => {
        nids = nids + ',' + element.nid;
      });
      nids = nids.substring(1);
      request({
        url: '/srsDevice/setAgent.do',
        method: 'get',
        params: {
          nids: nids,
          agentId: thiz.distributeAgent,
        }
      }).then(res => {
        console.log(JSON.stringify(res));
        if (res.data == 0) {
          thiz.$message.success('设置成功！');
          thiz.updateTable();
          thiz.distributeVisible = false;
        }
      })
    }

  }
}
</script>

<style>
.el-table {
  font-size: 12px;
  border-bottom: 1px solid #dcd8d8;
  color: black;
}

.el-table tr th {
  border-top: 0px;
  border-left: 0px;
  border-right: 0px;
}

.el-table tr td {
  border-bottom: 1px solid #dcd8d8;
}

.cardDivClass .el-card__header {
  padding-top: 8px;
  padding-bottom: 8px;
}

.cardDivClass .el-card__body {
  padding-top: 15px;
  padding-bottom: 20px;
}

.detailtd {
  font-weight: bold;
}

.log-div {
  height: 470px;
}

.log-li {
  width: 100%;
  /*color: ;*/
  /*text-align: center;*/
  border-bottom: solid #85ce61 1px;
}
</style>
